import {useQuery} from 'react-query'

async function getParents(token)
{
    const response = await fetch(`${process.env.REACT_APP_API_KEY}api/v1/admin/getall/parent`,{
        headers:{
            "Authorization":token
        }
    })
    return response.json()
}

export const useAdminParents = (token)=>
{
    return useQuery('get-admin-parents',()=>getParents(token))
}